<template>
	<form>
		<a  v-if="(descargar && requiereRespuesta == 'no')" :href="!href ? `/documentos/${documentoId}/descargar` : href" class="btn btn-sm btn-success text-black text-decoration-none" role="button" style="color:#000;"><i class="fas fa-cloud-upload-alt mr-1"></i>Descargar</a>	
		<button type="button" v-if="(descargar && (requiereRespuesta == 'no') && !usuarioPrincipal) || (descargar && (requiereRespuesta == 'si'))" @click="seleccionar" :class="'btn btn-sm btn-' + (descargar ? 'warning' : 'success')">
			<i v-if="descargar" class="fas fa-cloud-upload-alt mr-1"></i>
			<span v-if="(descargar && (requiereRespuesta == 'no') && !usuarioPrincipal) || (descargar && (requiereRespuesta == 'si'))">Subir nuevamente</span>
			<span v-if="!descargar">Cargar archivo</span>
		</button>
		<input hidden type="file" :name="nombreArchivo" :id="'uploadFile'+this._uid" accept=".pdf">
		<a v-if="!usuarioPrincipal && descargarExpediente" :href="descargarExpediente" class="btn btn-sm btn-primary text-black text-decoration-none" role="button" style="color:#000;"><i class="fas fa-cloud-upload-alt mr-1"></i>Descargar expediente</a>	
	</form>
</template>
<script>
import Axios from 'axios';
export default {
	props: [
	'descargarExpediente',
	'requiereRespuesta',
	'usuarioPrincipal',
	'nombreArchivo',
	'documentoId',
	'descargar',
	'esVisible',
	'href',
	'url',
	],
	mounted() {
		const vm = this;

		vm.$on('openDialog', function() {
			$('#uploadFile'+vm._uid).click();
		});

		$('#uploadFile'+vm._uid).on('change', function (e) {		
			const formData = new FormData();
			if (!e.target.files[0]) {Command: toastr["error"]('Ocurrió un error al cargar el archivo por favor contacte al administrador'); return; }
			if (e.target.files[0].size > 5 * 1024 * 1024) { Command: toastr["error"]('El tamaño del archivo no debe ser mayor a 5MB'); return; }
			formData.append(vm.nombreArchivo, e.target.files[0])
			vm.upload(formData);
		});
	},
	methods: {
		seleccionar() {  

			this.$emit('openDialog');
			
		},
		upload(data) {		
			axios.post(this.url, data, {
				headers: {'Content-Type': 'multipart/form-data'}
			}).then(response => {
				this.$parent.$emit('docChange', response.data);
				if (response.data) { toastr["success"]('Archivo cargado correctamente'); }
				
			}).catch(error => { 
				if (error.response.status === 422) { const requestErrors = (typeof(error.response.data.errors) !== 'undefined') ? error.response.data.errors : null; Object.keys(requestErrors).map(function(campo) { toastr["error"](requestErrors[campo]); }); }
			});

		}
	}
}
</script>
